/**
* Blog Roll JS
* -----------------------------------------------------------------------------
*
* All the JS for the Blog Roll component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'blog-roll',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.blog-roll' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--blog-roll' )[0], {
          pagination: false,
          perPage: 3,
          perMove: 1,
          gap: '32px',
          keyboard: true,
          breakpoints: {
            767: {
              perPage: 1,
            },
          },
        } );

        splide.mount();

        $( window ).on( 'resize', function() {
          if ( $( component ).find( '.splide' ).hasClass( 'is-overflow' ) ) {
            $( component ).find( '.slider-navigation' ).removeClass( 'hidden' );
          } else {
            $( component ).find( '.slider-navigation' ).addClass( 'hidden' );
          }
        } );

        if ( $( component ).find( '.splide' ).hasClass( 'is-overflow' ) ) {
          $( component ).find( '.slider-navigation' ).removeClass( 'hidden' );
        } else {
          $( component ).find( '.slider-navigation' ).addClass( 'hidden' );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'blog-roll', COMPONENT );
} )( app );
